// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none,ts_nocheck=true"
// @generated from file pull_requests/v1/repo_pulls_dashboard.proto (package github.pull_requests.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { SafeHtml } from "../../common/v1/safe_html_pb";
import { file_common_v1_safe_html } from "../../common/v1/safe_html_pb";
import { file_google_protobuf_wrappers } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file pull_requests/v1/repo_pulls_dashboard.proto.
 */
export const file_pull_requests_v1_repo_pulls_dashboard: GenFile = /*@__PURE__*/
  fileDesc("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", [file_common_v1_safe_html, file_google_protobuf_wrappers]);

/**
 * Blocking result payload for GET /:owner/:repo/pulls.
 *
 * @generated from message github.pull_requests.v1.RepoPullsDashboardContentResponse
 */
export type RepoPullsDashboardContentResponse = Message<"github.pull_requests.v1.RepoPullsDashboardContentResponse"> & {
  /**
   * @generated from field: repeated github.pull_requests.v1.RepoPullRequest results = 1;
   */
  results: RepoPullRequest[];

  /**
   * @generated from field: int32 current_page = 2;
   */
  currentPage: number;

  /**
   * @generated from field: int32 total_pages = 3;
   */
  totalPages: number;

  /**
   * @generated from field: int32 total_count = 4;
   */
  totalCount: number;

  /**
   * @generated from field: google.protobuf.StringValue error = 7;
   */
  error?: string;

  /**
   * @generated from field: google.protobuf.Int32Value open_count = 8;
   */
  openCount?: number;

  /**
   * @generated from field: google.protobuf.Int32Value closed_count = 9;
   */
  closedCount?: number;
};

/**
 * Describes the message github.pull_requests.v1.RepoPullsDashboardContentResponse.
 * Use `create(RepoPullsDashboardContentResponseSchema)` to create a new message.
 */
export const RepoPullsDashboardContentResponseSchema: GenMessage<RepoPullsDashboardContentResponse> = /*@__PURE__*/
  messageDesc(file_pull_requests_v1_repo_pulls_dashboard, 0);

/**
 * Stable layout preferences for GET /:owner/:repo/pulls/_layout.
 *
 * @generated from message github.pull_requests.v1.RepoPullsDashboardLayoutResponse
 */
export type RepoPullsDashboardLayoutResponse = Message<"github.pull_requests.v1.RepoPullsDashboardLayoutResponse"> & {
  /**
   * @generated from field: bool compact_mode = 1;
   */
  compactMode: boolean;

  /**
   * @generated from field: github.pull_requests.v1.RepoPullsDashboardActions actions = 2;
   */
  actions?: RepoPullsDashboardActions;

  /**
   * @generated from field: google.protobuf.BoolValue sidebar_expanded = 3;
   */
  sidebarExpanded?: boolean;

  /**
   * @generated from field: github.pull_requests.v1.RepoPullsDashboardRepository repository = 4;
   */
  repository?: RepoPullsDashboardRepository;
};

/**
 * Describes the message github.pull_requests.v1.RepoPullsDashboardLayoutResponse.
 * Use `create(RepoPullsDashboardLayoutResponseSchema)` to create a new message.
 */
export const RepoPullsDashboardLayoutResponseSchema: GenMessage<RepoPullsDashboardLayoutResponse> = /*@__PURE__*/
  messageDesc(file_pull_requests_v1_repo_pulls_dashboard, 1);

/**
 * @generated from message github.pull_requests.v1.RepoPullsDashboardActions
 */
export type RepoPullsDashboardActions = Message<"github.pull_requests.v1.RepoPullsDashboardActions"> & {
  /**
   * @generated from field: github.pull_requests.v1.RepoPullsDashboardLink labels = 1;
   */
  labels?: RepoPullsDashboardLink;

  /**
   * @generated from field: github.pull_requests.v1.RepoPullsDashboardLink milestones = 2;
   */
  milestones?: RepoPullsDashboardLink;

  /**
   * @generated from field: github.pull_requests.v1.RepoPullsDashboardPrimaryAction new_pull_request = 3;
   */
  newPullRequest?: RepoPullsDashboardPrimaryAction;

  /**
   * @generated from field: github.pull_requests.v1.RepoPullsDashboardAgentTaskRepository agent_task_repository = 4;
   */
  agentTaskRepository?: RepoPullsDashboardAgentTaskRepository;

  /**
   * @generated from field: bool can_bulk_update = 5;
   */
  canBulkUpdate: boolean;

  /**
   * @generated from field: bool can_bulk_add_to_projects = 6;
   */
  canBulkAddToProjects: boolean;

  /**
   * @generated from field: bool can_bulk_archive = 7;
   */
  canBulkArchive: boolean;
};

/**
 * Describes the message github.pull_requests.v1.RepoPullsDashboardActions.
 * Use `create(RepoPullsDashboardActionsSchema)` to create a new message.
 */
export const RepoPullsDashboardActionsSchema: GenMessage<RepoPullsDashboardActions> = /*@__PURE__*/
  messageDesc(file_pull_requests_v1_repo_pulls_dashboard, 2);

/**
 * @generated from message github.pull_requests.v1.RepoPullsDashboardAgentTaskRepository
 */
export type RepoPullsDashboardAgentTaskRepository = Message<"github.pull_requests.v1.RepoPullsDashboardAgentTaskRepository"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string owner_login = 3;
   */
  ownerLogin: string;

  /**
   * @generated from field: string default_branch = 4;
   */
  defaultBranch: string;

  /**
   * @generated from field: bool private = 5;
   */
  private: boolean;

  /**
   * @generated from field: string created_at = 6;
   */
  createdAt: string;

  /**
   * @generated from field: bool current_user_can_push = 7;
   */
  currentUserCanPush: boolean;

  /**
   * @generated from field: bool is_fork = 8;
   */
  isFork: boolean;

  /**
   * @generated from field: bool is_empty = 9;
   */
  isEmpty: boolean;

  /**
   * @generated from field: string owner_avatar = 10;
   */
  ownerAvatar: string;

  /**
   * @generated from field: bool public = 11;
   */
  public: boolean;

  /**
   * @generated from field: bool is_org_owned = 12;
   */
  isOrgOwned: boolean;
};

/**
 * Describes the message github.pull_requests.v1.RepoPullsDashboardAgentTaskRepository.
 * Use `create(RepoPullsDashboardAgentTaskRepositorySchema)` to create a new message.
 */
export const RepoPullsDashboardAgentTaskRepositorySchema: GenMessage<RepoPullsDashboardAgentTaskRepository> = /*@__PURE__*/
  messageDesc(file_pull_requests_v1_repo_pulls_dashboard, 3);

/**
 * @generated from message github.pull_requests.v1.RepoPullsDashboardRepository
 */
export type RepoPullsDashboardRepository = Message<"github.pull_requests.v1.RepoPullsDashboardRepository"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string owner_login = 3;
   */
  ownerLogin: string;

  /**
   * @generated from field: string default_branch = 4;
   */
  defaultBranch: string;

  /**
   * @generated from field: bool private = 5;
   */
  private: boolean;

  /**
   * @generated from field: string created_at = 6;
   */
  createdAt: string;

  /**
   * @generated from field: bool current_user_can_push = 7;
   */
  currentUserCanPush: boolean;

  /**
   * @generated from field: bool is_fork = 8;
   */
  isFork: boolean;

  /**
   * @generated from field: bool is_empty = 9;
   */
  isEmpty: boolean;

  /**
   * @generated from field: string owner_avatar = 10;
   */
  ownerAvatar: string;

  /**
   * @generated from field: bool public = 11;
   */
  public: boolean;

  /**
   * @generated from field: bool is_org_owned = 12;
   */
  isOrgOwned: boolean;
};

/**
 * Describes the message github.pull_requests.v1.RepoPullsDashboardRepository.
 * Use `create(RepoPullsDashboardRepositorySchema)` to create a new message.
 */
export const RepoPullsDashboardRepositorySchema: GenMessage<RepoPullsDashboardRepository> = /*@__PURE__*/
  messageDesc(file_pull_requests_v1_repo_pulls_dashboard, 4);

/**
 * @generated from message github.pull_requests.v1.RepoPullsDashboardLink
 */
export type RepoPullsDashboardLink = Message<"github.pull_requests.v1.RepoPullsDashboardLink"> & {
  /**
   * @generated from field: string url = 1;
   */
  url: string;

  /**
   * @generated from field: int32 count = 2;
   */
  count: number;
};

/**
 * Describes the message github.pull_requests.v1.RepoPullsDashboardLink.
 * Use `create(RepoPullsDashboardLinkSchema)` to create a new message.
 */
export const RepoPullsDashboardLinkSchema: GenMessage<RepoPullsDashboardLink> = /*@__PURE__*/
  messageDesc(file_pull_requests_v1_repo_pulls_dashboard, 5);

/**
 * @generated from message github.pull_requests.v1.RepoPullsDashboardPrimaryAction
 */
export type RepoPullsDashboardPrimaryAction = Message<"github.pull_requests.v1.RepoPullsDashboardPrimaryAction"> & {
  /**
   * @generated from field: string label = 1;
   */
  label: string;

  /**
   * @generated from field: google.protobuf.StringValue url = 2;
   */
  url?: string;

  /**
   * @generated from field: google.protobuf.StringValue disabled_reason = 3;
   */
  disabledReason?: string;
};

/**
 * Describes the message github.pull_requests.v1.RepoPullsDashboardPrimaryAction.
 * Use `create(RepoPullsDashboardPrimaryActionSchema)` to create a new message.
 */
export const RepoPullsDashboardPrimaryActionSchema: GenMessage<RepoPullsDashboardPrimaryAction> = /*@__PURE__*/
  messageDesc(file_pull_requests_v1_repo_pulls_dashboard, 6);

/**
 * Non-blocking row enrichment for GET /:owner/:repo/pulls/_deferred.
 *
 * @generated from message github.pull_requests.v1.RepoPullsDashboardDeferredResponse
 */
export type RepoPullsDashboardDeferredResponse = Message<"github.pull_requests.v1.RepoPullsDashboardDeferredResponse"> & {
  /**
   * @generated from field: repeated github.pull_requests.v1.RepoPullRequestDeferredResult results = 1;
   */
  results: RepoPullRequestDeferredResult[];

  /**
   * @generated from field: google.protobuf.StringValue error = 2;
   */
  error?: string;
};

/**
 * Describes the message github.pull_requests.v1.RepoPullsDashboardDeferredResponse.
 * Use `create(RepoPullsDashboardDeferredResponseSchema)` to create a new message.
 */
export const RepoPullsDashboardDeferredResponseSchema: GenMessage<RepoPullsDashboardDeferredResponse> = /*@__PURE__*/
  messageDesc(file_pull_requests_v1_repo_pulls_dashboard, 7);

/**
 * @generated from message github.pull_requests.v1.RepoPullRequest
 */
export type RepoPullRequest = Message<"github.pull_requests.v1.RepoPullRequest"> & {
  /**
   * @generated from field: repeated github.pull_requests.v1.RepoPullRequestAssignee assignees = 1;
   */
  assignees: RepoPullRequestAssignee[];

  /**
   * @generated from field: github.pull_requests.v1.RepoPullRequestAuthor author = 2;
   */
  author?: RepoPullRequestAuthor;

  /**
   * @generated from field: int32 comment_count = 3;
   */
  commentCount: number;

  /**
   * @generated from field: google.protobuf.StringValue commit_head_sha_channel = 4;
   */
  commitHeadShaChannel?: string;

  /**
   * @generated from field: github.pull_requests.v1.RepoPullRequestAgentAttributedUser agent_attributed_user = 5;
   */
  agentAttributedUser?: RepoPullRequestAgentAttributedUser;

  /**
   * @generated from field: string created_at = 6;
   */
  createdAt: string;

  /**
   * @generated from field: string updated_at = 7;
   */
  updatedAt: string;

  /**
   * @generated from field: github.pull_requests.v1.RepoPullRequestDisplayState display_state = 8;
   */
  displayState: RepoPullRequestDisplayState;

  /**
   * @generated from field: google.protobuf.StringValue head_sha = 9;
   */
  headSha?: string;

  /**
   * @generated from field: repeated github.pull_requests.v1.RepoPullRequestLabel labels = 10;
   */
  labels: RepoPullRequestLabel[];

  /**
   * @generated from field: int64 id = 11;
   */
  id: bigint;

  /**
   * @generated from field: google.protobuf.StringValue global_id = 12;
   */
  globalId?: string;

  /**
   * @generated from field: bool is_draft = 13;
   */
  isDraft: boolean;

  /**
   * @generated from field: bool is_read_by_current_user = 14;
   */
  isReadByCurrentUser: boolean;

  /**
   * @generated from field: int32 number = 15;
   */
  number: number;

  /**
   * @generated from field: google.protobuf.StringValue permalink = 16;
   */
  permalink?: string;

  /**
   * @generated from field: google.protobuf.StringValue repo_name_with_owner = 17;
   */
  repoNameWithOwner?: string;

  /**
   * @generated from field: google.protobuf.Int32Value stack_position = 18;
   */
  stackPosition?: number;

  /**
   * @generated from field: google.protobuf.Int32Value stack_size = 19;
   */
  stackSize?: number;

  /**
   * @generated from field: github.pull_requests.v1.RepoPullRequestState state = 20;
   */
  state: RepoPullRequestState;

  /**
   * @generated from field: string title = 21;
   */
  title: string;

  /**
   * @generated from field: github.common.v1.SafeHtml title_html = 22;
   */
  titleHtml?: SafeHtml;

  /**
   * @generated from field: google.protobuf.StringValue merge_queue_url = 23;
   */
  mergeQueueUrl?: string;

  /**
   * @generated from field: github.pull_requests.v1.RepoPullRequestMilestone milestone = 24;
   */
  milestone?: RepoPullRequestMilestone;

  /**
   * @generated from field: int32 linked_issue_count = 25;
   */
  linkedIssueCount: number;

  /**
   * @generated from field: google.protobuf.StringValue linked_issue_url = 26;
   */
  linkedIssueUrl?: string;

  /**
   * When the pull request was most recently closed; unset while open.
   *
   * @generated from field: google.protobuf.StringValue closed_at = 27;
   */
  closedAt?: string;

  /**
   * @generated from field: google.protobuf.StringValue merged_at = 28;
   */
  mergedAt?: string;

  /**
   * @generated from field: google.protobuf.Int32Value task_list_item_count = 29;
   */
  taskListItemCount?: number;

  /**
   * @generated from field: google.protobuf.Int32Value complete_task_list_item_count = 30;
   */
  completeTaskListItemCount?: number;
};

/**
 * Describes the message github.pull_requests.v1.RepoPullRequest.
 * Use `create(RepoPullRequestSchema)` to create a new message.
 */
export const RepoPullRequestSchema: GenMessage<RepoPullRequest> = /*@__PURE__*/
  messageDesc(file_pull_requests_v1_repo_pulls_dashboard, 8);

/**
 * @generated from message github.pull_requests.v1.RepoPullRequestMilestone
 */
export type RepoPullRequestMilestone = Message<"github.pull_requests.v1.RepoPullRequestMilestone"> & {
  /**
   * @generated from field: string title = 1;
   */
  title: string;

  /**
   * @generated from field: string url = 2;
   */
  url: string;
};

/**
 * Describes the message github.pull_requests.v1.RepoPullRequestMilestone.
 * Use `create(RepoPullRequestMilestoneSchema)` to create a new message.
 */
export const RepoPullRequestMilestoneSchema: GenMessage<RepoPullRequestMilestone> = /*@__PURE__*/
  messageDesc(file_pull_requests_v1_repo_pulls_dashboard, 9);

/**
 * @generated from message github.pull_requests.v1.RepoPullRequestAssignee
 */
export type RepoPullRequestAssignee = Message<"github.pull_requests.v1.RepoPullRequestAssignee"> & {
  /**
   * @generated from field: string login = 1;
   */
  login: string;

  /**
   * @generated from field: string avatar_url = 2;
   */
  avatarUrl: string;

  /**
   * @generated from field: bool is_copilot = 3;
   */
  isCopilot: boolean;

  /**
   * The value for an `assignee:` search qualifier: the login for users, `Bot#to_query_filter` for bots
   * (e.g. "@copilot", "@claude[agent]", "app/dependabot").
   *
   * @generated from field: string filter_value = 4;
   */
  filterValue: string;
};

/**
 * Describes the message github.pull_requests.v1.RepoPullRequestAssignee.
 * Use `create(RepoPullRequestAssigneeSchema)` to create a new message.
 */
export const RepoPullRequestAssigneeSchema: GenMessage<RepoPullRequestAssignee> = /*@__PURE__*/
  messageDesc(file_pull_requests_v1_repo_pulls_dashboard, 10);

/**
 * @generated from message github.pull_requests.v1.RepoPullRequestAuthor
 */
export type RepoPullRequestAuthor = Message<"github.pull_requests.v1.RepoPullRequestAuthor"> & {
  /**
   * @generated from field: string display_login = 1;
   */
  displayLogin: string;

  /**
   * @generated from field: github.pull_requests.v1.RepoPullRequestAuthorAssociation association = 2;
   */
  association: RepoPullRequestAuthorAssociation;

  /**
   * @generated from field: github.pull_requests.v1.RepoPullRequestAuthorIdentity identity = 3;
   */
  identity: RepoPullRequestAuthorIdentity;

  /**
   * Optional organization-configured label; display_login remains the identity.
   *
   * @generated from field: google.protobuf.StringValue display_name = 4;
   */
  displayName?: string;
};

/**
 * Describes the message github.pull_requests.v1.RepoPullRequestAuthor.
 * Use `create(RepoPullRequestAuthorSchema)` to create a new message.
 */
export const RepoPullRequestAuthorSchema: GenMessage<RepoPullRequestAuthor> = /*@__PURE__*/
  messageDesc(file_pull_requests_v1_repo_pulls_dashboard, 11);

/**
 * @generated from message github.pull_requests.v1.RepoPullRequestAgentAttributedUser
 */
export type RepoPullRequestAgentAttributedUser = Message<"github.pull_requests.v1.RepoPullRequestAgentAttributedUser"> & {
  /**
   * @generated from field: string display_login = 1;
   */
  displayLogin: string;
};

/**
 * Describes the message github.pull_requests.v1.RepoPullRequestAgentAttributedUser.
 * Use `create(RepoPullRequestAgentAttributedUserSchema)` to create a new message.
 */
export const RepoPullRequestAgentAttributedUserSchema: GenMessage<RepoPullRequestAgentAttributedUser> = /*@__PURE__*/
  messageDesc(file_pull_requests_v1_repo_pulls_dashboard, 12);

/**
 * @generated from message github.pull_requests.v1.RepoPullRequestLabel
 */
export type RepoPullRequestLabel = Message<"github.pull_requests.v1.RepoPullRequestLabel"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: google.protobuf.StringValue color = 3;
   */
  color?: string;

  /**
   * @generated from field: google.protobuf.StringValue description = 4;
   */
  description?: string;

  /**
   * @generated from field: github.common.v1.SafeHtml name_html = 5;
   */
  nameHtml?: SafeHtml;
};

/**
 * Describes the message github.pull_requests.v1.RepoPullRequestLabel.
 * Use `create(RepoPullRequestLabelSchema)` to create a new message.
 */
export const RepoPullRequestLabelSchema: GenMessage<RepoPullRequestLabel> = /*@__PURE__*/
  messageDesc(file_pull_requests_v1_repo_pulls_dashboard, 13);

/**
 * @generated from message github.pull_requests.v1.RepoPullRequestDeferredResult
 */
export type RepoPullRequestDeferredResult = Message<"github.pull_requests.v1.RepoPullRequestDeferredResult"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: google.protobuf.StringValue global_id = 2;
   */
  globalId?: string;

  /**
   * @generated from field: github.pull_requests.v1.RepoPullRequestReviewDecision review_decision_state = 3;
   */
  reviewDecisionState: RepoPullRequestReviewDecision;

  /**
   * @generated from field: github.pull_requests.v1.RepoPullRequestStatusCheckRollup status_check_rollup = 4;
   */
  statusCheckRollup?: RepoPullRequestStatusCheckRollup;

  /**
   * @generated from field: google.protobuf.Int32Value approved_reviews_count = 5;
   */
  approvedReviewsCount?: number;

  /**
   * @generated from field: google.protobuf.Int32Value changes_requested_reviews_count = 6;
   */
  changesRequestedReviewsCount?: number;
};

/**
 * Describes the message github.pull_requests.v1.RepoPullRequestDeferredResult.
 * Use `create(RepoPullRequestDeferredResultSchema)` to create a new message.
 */
export const RepoPullRequestDeferredResultSchema: GenMessage<RepoPullRequestDeferredResult> = /*@__PURE__*/
  messageDesc(file_pull_requests_v1_repo_pulls_dashboard, 14);

/**
 * @generated from message github.pull_requests.v1.RepoPullRequestStatusCheckRollup
 */
export type RepoPullRequestStatusCheckRollup = Message<"github.pull_requests.v1.RepoPullRequestStatusCheckRollup"> & {
  /**
   * @generated from field: github.pull_requests.v1.RepoPullRequestStatusCheckState state = 1;
   */
  state: RepoPullRequestStatusCheckState;

  /**
   * @generated from field: int32 total_count = 2;
   */
  totalCount: number;

  /**
   * @generated from field: int32 success_count = 3;
   */
  successCount: number;
};

/**
 * Describes the message github.pull_requests.v1.RepoPullRequestStatusCheckRollup.
 * Use `create(RepoPullRequestStatusCheckRollupSchema)` to create a new message.
 */
export const RepoPullRequestStatusCheckRollupSchema: GenMessage<RepoPullRequestStatusCheckRollup> = /*@__PURE__*/
  messageDesc(file_pull_requests_v1_repo_pulls_dashboard, 15);

/**
 * @generated from enum github.pull_requests.v1.RepoPullRequestDisplayState
 */
export enum RepoPullRequestDisplayState {
  /**
   * @generated from enum value: REPO_PULL_REQUEST_DISPLAY_STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: REPO_PULL_REQUEST_DISPLAY_STATE_DRAFT = 1;
   */
  DRAFT = 1,

  /**
   * @generated from enum value: REPO_PULL_REQUEST_DISPLAY_STATE_OPEN = 2;
   */
  OPEN = 2,

  /**
   * @generated from enum value: REPO_PULL_REQUEST_DISPLAY_STATE_CLOSED = 3;
   */
  CLOSED = 3,

  /**
   * @generated from enum value: REPO_PULL_REQUEST_DISPLAY_STATE_MERGED = 4;
   */
  MERGED = 4,

  /**
   * @generated from enum value: REPO_PULL_REQUEST_DISPLAY_STATE_QUEUED = 5;
   */
  QUEUED = 5,
}

/**
 * Describes the enum github.pull_requests.v1.RepoPullRequestDisplayState.
 */
export const RepoPullRequestDisplayStateSchema: GenEnum<RepoPullRequestDisplayState> = /*@__PURE__*/
  enumDesc(file_pull_requests_v1_repo_pulls_dashboard, 0);

/**
 * @generated from enum github.pull_requests.v1.RepoPullRequestState
 */
export enum RepoPullRequestState {
  /**
   * @generated from enum value: REPO_PULL_REQUEST_STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: REPO_PULL_REQUEST_STATE_OPEN = 1;
   */
  OPEN = 1,

  /**
   * @generated from enum value: REPO_PULL_REQUEST_STATE_CLOSED = 2;
   */
  CLOSED = 2,

  /**
   * @generated from enum value: REPO_PULL_REQUEST_STATE_MERGED = 3;
   */
  MERGED = 3,
}

/**
 * Describes the enum github.pull_requests.v1.RepoPullRequestState.
 */
export const RepoPullRequestStateSchema: GenEnum<RepoPullRequestState> = /*@__PURE__*/
  enumDesc(file_pull_requests_v1_repo_pulls_dashboard, 1);

/**
 * @generated from enum github.pull_requests.v1.RepoPullRequestAuthorAssociation
 */
export enum RepoPullRequestAuthorAssociation {
  /**
   * @generated from enum value: REPO_PULL_REQUEST_AUTHOR_ASSOCIATION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: REPO_PULL_REQUEST_AUTHOR_ASSOCIATION_COLLABORATOR = 1;
   */
  COLLABORATOR = 1,

  /**
   * @generated from enum value: REPO_PULL_REQUEST_AUTHOR_ASSOCIATION_CONTRIBUTOR = 2;
   */
  CONTRIBUTOR = 2,

  /**
   * @generated from enum value: REPO_PULL_REQUEST_AUTHOR_ASSOCIATION_FIRST_TIMER = 3;
   */
  FIRST_TIMER = 3,

  /**
   * @generated from enum value: REPO_PULL_REQUEST_AUTHOR_ASSOCIATION_FIRST_TIME_CONTRIBUTOR = 4;
   */
  FIRST_TIME_CONTRIBUTOR = 4,

  /**
   * @generated from enum value: REPO_PULL_REQUEST_AUTHOR_ASSOCIATION_MANNEQUIN = 5;
   */
  MANNEQUIN = 5,

  /**
   * @generated from enum value: REPO_PULL_REQUEST_AUTHOR_ASSOCIATION_MEMBER = 6;
   */
  MEMBER = 6,

  /**
   * @generated from enum value: REPO_PULL_REQUEST_AUTHOR_ASSOCIATION_NONE = 7;
   */
  NONE = 7,

  /**
   * @generated from enum value: REPO_PULL_REQUEST_AUTHOR_ASSOCIATION_OWNER = 8;
   */
  OWNER = 8,
}

/**
 * Describes the enum github.pull_requests.v1.RepoPullRequestAuthorAssociation.
 */
export const RepoPullRequestAuthorAssociationSchema: GenEnum<RepoPullRequestAuthorAssociation> = /*@__PURE__*/
  enumDesc(file_pull_requests_v1_repo_pulls_dashboard, 2);

/**
 * @generated from enum github.pull_requests.v1.RepoPullRequestAuthorIdentity
 */
export enum RepoPullRequestAuthorIdentity {
  /**
   * @generated from enum value: REPO_PULL_REQUEST_AUTHOR_IDENTITY_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: REPO_PULL_REQUEST_AUTHOR_IDENTITY_BOT = 1;
   */
  BOT = 1,

  /**
   * @generated from enum value: REPO_PULL_REQUEST_AUTHOR_IDENTITY_AI = 2;
   */
  AI = 2,

  /**
   * @generated from enum value: REPO_PULL_REQUEST_AUTHOR_IDENTITY_MANNEQUIN = 3;
   */
  MANNEQUIN = 3,
}

/**
 * Describes the enum github.pull_requests.v1.RepoPullRequestAuthorIdentity.
 */
export const RepoPullRequestAuthorIdentitySchema: GenEnum<RepoPullRequestAuthorIdentity> = /*@__PURE__*/
  enumDesc(file_pull_requests_v1_repo_pulls_dashboard, 3);

/**
 * @generated from enum github.pull_requests.v1.RepoPullRequestReviewDecision
 */
export enum RepoPullRequestReviewDecision {
  /**
   * @generated from enum value: REPO_PULL_REQUEST_REVIEW_DECISION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: REPO_PULL_REQUEST_REVIEW_DECISION_APPROVED = 1;
   */
  APPROVED = 1,

  /**
   * @generated from enum value: REPO_PULL_REQUEST_REVIEW_DECISION_CHANGES_REQUESTED = 2;
   */
  CHANGES_REQUESTED = 2,

  /**
   * @generated from enum value: REPO_PULL_REQUEST_REVIEW_DECISION_REQUIRED = 3;
   */
  REQUIRED = 3,
}

/**
 * Describes the enum github.pull_requests.v1.RepoPullRequestReviewDecision.
 */
export const RepoPullRequestReviewDecisionSchema: GenEnum<RepoPullRequestReviewDecision> = /*@__PURE__*/
  enumDesc(file_pull_requests_v1_repo_pulls_dashboard, 4);

/**
 * @generated from enum github.pull_requests.v1.RepoPullRequestStatusCheckState
 */
export enum RepoPullRequestStatusCheckState {
  /**
   * @generated from enum value: REPO_PULL_REQUEST_STATUS_CHECK_STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: REPO_PULL_REQUEST_STATUS_CHECK_STATE_SUCCESS = 1;
   */
  SUCCESS = 1,

  /**
   * @generated from enum value: REPO_PULL_REQUEST_STATUS_CHECK_STATE_FAILURE = 2;
   */
  FAILURE = 2,

  /**
   * @generated from enum value: REPO_PULL_REQUEST_STATUS_CHECK_STATE_PENDING = 3;
   */
  PENDING = 3,
}

/**
 * Describes the enum github.pull_requests.v1.RepoPullRequestStatusCheckState.
 */
export const RepoPullRequestStatusCheckStateSchema: GenEnum<RepoPullRequestStatusCheckState> = /*@__PURE__*/
  enumDesc(file_pull_requests_v1_repo_pulls_dashboard, 5);

import { registerSchemaHash } from "../../../schema-hash-registry";
registerSchemaHash(RepoPullsDashboardContentResponseSchema, "3698a4d89651")
registerSchemaHash(RepoPullsDashboardLayoutResponseSchema, "2cdcdbf0aa27")
registerSchemaHash(RepoPullsDashboardActionsSchema, "ca899cb5ca24")
registerSchemaHash(RepoPullsDashboardAgentTaskRepositorySchema, "0945942ac7cc")
registerSchemaHash(RepoPullsDashboardRepositorySchema, "4b3f9deb45c9")
registerSchemaHash(RepoPullsDashboardLinkSchema, "8bb55c398111")
registerSchemaHash(RepoPullsDashboardPrimaryActionSchema, "4285a226cda5")
registerSchemaHash(RepoPullsDashboardDeferredResponseSchema, "9d9f65fab8ec")
registerSchemaHash(RepoPullRequestSchema, "23f08e6a2d12")
registerSchemaHash(RepoPullRequestMilestoneSchema, "23e2c661621a")
registerSchemaHash(RepoPullRequestAssigneeSchema, "b258f7a1d21a")
registerSchemaHash(RepoPullRequestAuthorSchema, "00e8cd68df0b")
registerSchemaHash(RepoPullRequestAgentAttributedUserSchema, "92246f476ca4")
registerSchemaHash(RepoPullRequestLabelSchema, "156061f5277f")
registerSchemaHash(RepoPullRequestDeferredResultSchema, "f312c89fd242")
registerSchemaHash(RepoPullRequestStatusCheckRollupSchema, "016c22b10868")
